import React, { useState, useEffect } from "react";
import { Button } from "@nextui-org/react";
import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from "@nextui-org/react";
import { Chip } from "@nextui-org/react";
import { Card, CardBody } from "@nextui-org/react";
import { Pagination } from "@nextui-org/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faGripVertical,
  faTable,
  faRefresh,
  faPlus,
  faChartLine
} from "@fortawesome/free-solid-svg-icons";
import BreadCrumbsPage from "../../components/BreadCrumbsPage";
import { getAlldata } from "../../controllers/APIController";
import { useNavigate } from "react-router-dom";
import CreateTaskModal from "./CreateTaskModal";

import { PageLoader } from "../../components/Loader";
import { useQuery, useQueryClient } from "@tanstack/react-query";

const TaskControlTrackerMain = () => {
  const navigate = useNavigate();
  const [layoutMode, setLayoutMode] = useState("cards");
  const [currentPage, setCurrentPage] = useState(1);
  const [metrics, setMetrics] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const clientQuery= useQueryClient()
 const { data: TaskData,isPending } = useQuery({
   queryKey: ["tasks"],
   queryFn: () => getAlldata("tasks"),
 });

  useEffect(() => {
    // Handle different response structures
    let tasksData = [];
    if (TaskData && Array.isArray(TaskData)) {
      tasksData = TaskData;
    } else if (TaskData && TaskData.data && Array.isArray(TaskData.data)) {
      tasksData = TaskData.data;
    } else if (TaskData && TaskData.data && Array.isArray(TaskData.data.data)) {
      tasksData = TaskData.data.data;
    } else {
      tasksData = [];
    }

    if (Array.isArray(tasksData) && tasksData.length > 0) {
      // Group tasks by metric
      const metricGroups = {};

      tasksData.forEach((task) => {
        if (task && task.attributes) {
          const taskData = task.attributes;
          const metricId = taskData.metric?.data?.id || taskData.metric;
          const metricData = taskData.metric?.data?.attributes || {};

          if (metricId) {
            if (!metricGroups[metricId]) {
              metricGroups[metricId] = {
                id: metricId,
                name: metricData.Name || metricData.name || "Unnamed Metric",
                description:
                  metricData.Description ||
                  metricData.description ||
                  "No description available",
                taskCount: 0,
                tasks: [],
              };
            }
            metricGroups[metricId].taskCount++;
            metricGroups[metricId].tasks.push(task);
          }
        }
      });

      const metricsArray = Object.values(metricGroups);
      console.log("Grouped metrics with task counts:", metricsArray);
      setMetrics(metricsArray);
    } else {
      console.log("No tasks found");
      setMetrics([]);
    }
  }, [TaskData]);

 

  // const fetchMetricsWithTaskCounts = async () => {
  //   try {
  //     setLoading(true);
  //     console.log("Fetching tasks to group by metrics...");

  //     const response = await getAlldata("tasks");
  //     console.log("Raw tasks response:", response);
  //     // Handle different response structures
  //     let tasksData = [];
  //     if (response && Array.isArray(response)) {
  //       tasksData = response;
  //     } else if (response && response.data && Array.isArray(response.data)) {
  //       tasksData = response.data;
  //     } else if (
  //       response &&
  //       response.data &&
  //       Array.isArray(response.data.data)
  //     ) {
  //       tasksData = response.data.data;
  //     } else {
  //       tasksData = [];
  //     }

  //     if (Array.isArray(tasksData) && tasksData.length > 0) {
  //       // Group tasks by metric
  //       const metricGroups = {};

  //       tasksData.forEach((task) => {
  //         if (task && task.attributes) {
  //           const taskData = task.attributes;
  //           const metricId = taskData.metric?.data?.id || taskData.metric;
  //           const metricData = taskData.metric?.data?.attributes || {};

  //           if (metricId) {
  //             if (!metricGroups[metricId]) {
  //               metricGroups[metricId] = {
  //                 id: metricId,
  //                 name: metricData.Name || metricData.name || "Unnamed Metric",
  //                 description:
  //                   metricData.Description ||
  //                   metricData.description ||
  //                   "No description available",
  //                 taskCount: 0,
  //                 tasks: [],
  //               };
  //             }
  //             metricGroups[metricId].taskCount++;
  //             metricGroups[metricId].tasks.push(task);
  //           }
  //         }
  //       });

  //       const metricsArray = Object.values(metricGroups);
  //       console.log("Grouped metrics with task counts:", metricsArray);
  //       setMetrics(metricsArray);
  //     } else {
  //       console.log("No tasks found");
  //       setMetrics([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching metrics with task counts:", error);
  //     setError(error.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSearch = (value) => {
    setSearchTerm(value);
    setCurrentPage(1);
  };

  const filteredMetrics = searchTerm.trim() === "" 
    ? metrics 
    : metrics.filter(metric =>
        metric.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        metric.description.toLowerCase().includes(searchTerm.toLowerCase())
      );

  const handleMetricClick = (metric) => {
    console.log("Clicking metric:", metric);
    console.log("Tasks for this metric:", metric.tasks);
    console.log("Metric ID:", metric.id);
    console.log("Tasks array length:", metric.tasks?.length);
    
    const navigationState = { 
      metricData: metric,
      tasksForMetric: metric.tasks // Pass the tasks we already have
    };
    
    console.log("Navigation state being passed:", navigationState);
    
    // Get the current organization ID from the URL
    const currentPath = window.location.pathname;
    const orgIdMatch = currentPath.match(/^\/([^\/]+)\//);
    const orgId = orgIdMatch ? orgIdMatch[1] : '';
    
    navigate(`/${orgId}/task-control-tracker/metric/${metric.id}`, { 
      state: navigationState
    });
  };

  const handleCreateTask = () => {
    setIsCreateModalOpen(true);
  };

  const handleCreateTaskSuccess = () => {
    // Refresh the metrics data to show the new task
    clientQuery.invalidateQueries({ queryKey: ["tasks"] });

  };

  const renderCardsView = () => {
    if (filteredMetrics.length === 0) {
      return (
        <div className="text-center py-12">
          <div className="text-slate-400 text-6xl mb-4">📊</div>
          <h3 className="text-lg font-medium text-slate-900 mb-2">No metrics found</h3>
          <p className="text-slate-600 mb-4">No metrics have tasks assigned to them yet.</p>
        </div>
      );
    }

    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredMetrics.map((metric, index) => (
          <Card 
            key={metric.id} 
            className="border border-slate-200 hover:border-emerald-300 transition-all duration-300 shadow-sm hover:shadow-lg cursor-pointer bg-gradient-to-br from-white to-slate-50"
            isPressable
            onPress={() => handleMetricClick(metric)}
          >
            <CardBody className="p-4">
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center gap-2">
                  <span className="bg-emerald-100 text-emerald-700 text-xs font-semibold px-2 py-1 rounded-full">
                    #{index + 1}
                  </span>
                  <Chip
                    size="sm"
                    color="success"
                    variant="flat"
                    className="text-xs"
                  >
                    {metric.taskCount} Tasks
                  </Chip>
                </div>
              </div>
              
              <h3 className="font-semibold text-slate-900 text-sm mb-2 line-clamp-2">
                {metric.name}
              </h3>
              
              <p className="text-xs text-slate-600 mb-3 line-clamp-3">
                {metric.description}
              </p>
              
                              <div className="space-y-2">
                  <div className="flex items-center justify-between text-xs">
                    <span className="text-slate-500">Task Count:</span>
                    <span className="font-medium text-slate-700">
                      {metric.taskCount}
                    </span>
                  </div>
                  

                  
                  <div className="flex items-center justify-between text-xs">
                    <span className="text-slate-500">Metric ID:</span>
                    <span className="font-medium text-slate-700">
                      {metric.id}
                    </span>
                  </div>
                </div>
            </CardBody>
          </Card>
        ))}
      </div>
    );
  };

  const renderTableView = () => {
    if (filteredMetrics.length === 0) {
      return (
        <div className="text-center py-12">
          <div className="text-slate-400 text-6xl mb-4">📊</div>
          <h3 className="text-lg font-medium text-slate-900 mb-2">No metrics found</h3>
          <p className="text-slate-600 mb-4">No metrics have tasks assigned to them yet.</p>
        </div>
      );
    }

    return (
      <div className="space-y-4">
        <Card className="border border-slate-200 shadow-sm">
          <CardBody className="p-0">
            <div className="px-4 py-3 border-b border-slate-200 bg-gradient-to-r from-emerald-50 to-white">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="font-semibold text-emerald-900">Metrics Overview</span>
                  <span className="text-sm text-emerald-600">Metrics with assigned tasks</span>
                </div>
                <div className="flex items-center gap-3">
                  <Chip
                    size="sm"
                    color="success"
                    variant="flat"
                    className="text-xs"
                  >
                    {filteredMetrics.length} Metrics
                  </Chip>
                  <span className="text-xs text-slate-500">
                    Total Tasks: {filteredMetrics.reduce((sum, m) => sum + m.taskCount, 0)}
                  </span>
                </div>
              </div>
            </div>
            
            <div className="p-4">
              <Table
                removeWrapper
                selectionMode="single"
                aria-label="metrics-table"
                classNames={{
                  th: "bg-slate-50 text-slate-700 font-semibold text-xs border-b border-slate-100 py-2",
                  td: "py-2 border-b border-slate-100 text-xs",
                }}
              >
                <TableHeader>
                  <TableColumn>Metric Name</TableColumn>
                  <TableColumn>Description</TableColumn>
                  <TableColumn>Tasks Assigned</TableColumn>
                </TableHeader>
                <TableBody>
                  {filteredMetrics.map((metric) => (
                    <TableRow 
                      key={metric.id} 
                      className="hover:bg-emerald-50 cursor-pointer transition-all duration-200 border-b border-slate-100"
                      onClick={() => handleMetricClick(metric)}
                      title="Click to view tasks for this metric"
                    >
                      <TableCell>
                        <div 
                          className="font-medium text-slate-900 flex items-center gap-2 group"
                        >
                          <span>{metric.name}</span>
                          <svg 
                            className="w-4 h-4 text-slate-400 group-hover:text-emerald-500 transition-colors" 
                            fill="none" 
                            stroke="currentColor" 
                            viewBox="0 0 24 24"
                          >
                            <path 
                              strokeLinecap="round" 
                              strokeLinejoin="round" 
                              strokeWidth={2} 
                              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" 
                            />
                          </svg>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className="text-slate-600 line-clamp-2 max-w-xs">
                          {metric.description}
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className="flex items-center gap-2">
                          <Chip size="sm" color="success" variant="flat">
                            {metric.taskCount}
                          </Chip>
                          <span className="text-xs text-slate-600">
                            {metric.taskCount === 1 ? 'task' : 'tasks'}
                          </span>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  };

  if (isPending) {
    return (
      <PageLoader
        loadingText="Loading metrics..."
        description="Fetching task data and grouping by metrics"
        variant="fullscreen"
      />
    );
  }

  if (error) {
    return (
      <PageLoader
        error={error}
        onRetry={() => clientQuery.invalidateQueries({ queryKey: ["tasks"] })}
        variant="fullscreen"
      />
    );
  }

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-white to-slate-50 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div>
                <h1 className="text-3xl font-bold text-slate-900">
                  Task Control & Tracker
                </h1>
                <p className="text-slate-600 mt-1">
                  Monitor metrics and their assigned task counts
                </p>
              </div>
            </div>
            <Button
              color="primary"
              size="sm"
              startContent={<FontAwesomeIcon icon={faPlus} />}
              className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 font-medium"
              onClick={handleCreateTask}
            >
              Create New Task
            </Button>
          </div>
        </div>
      </div>

      {/* Breadcrumbs */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-4 py-2">
        <BreadCrumbsPage />
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        {/* Search and Filter Section */}
        <div className="bg-white rounded-lg border shadow-sm p-4 mb-4">
          <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
            <div className="flex-1">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search metrics by name or description..."
                  value={searchTerm}
                  onChange={(e) => handleSearch(e.target.value)}
                  className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                />
              </div>
            </div>

            <div className="flex items-center gap-3">
              {/* Layout Toggle */}
              <div className="flex bg-slate-100 rounded-lg p-1">
                <Button
                  size="sm"
                  variant={layoutMode === "cards" ? "solid" : "light"}
                  color={layoutMode === "cards" ? "success" : "default"}
                  onClick={() => setLayoutMode("cards")}
                  className="px-3 py-1 text-xs"
                >
                  <FontAwesomeIcon
                    icon={faGripVertical}
                    className="w-3 h-3 mr-1"
                  />
                  Cards
                </Button>
                <Button
                  size="sm"
                  variant={layoutMode === "table" ? "solid" : "light"}
                  color={layoutMode === "table" ? "success" : "default"}
                  onClick={() => setLayoutMode("table")}
                  className="px-3 py-1 text-xs"
                >
                  <FontAwesomeIcon icon={faTable} className="w-3 h-3 mr-1" />
                  Table
                </Button>
              </div>

              {/* Refresh Button */}
              <Button
                variant="flat"
                startContent={<FontAwesomeIcon icon={faRefresh} />}
                onClick={() =>
                  clientQuery.invalidateQueries({ queryKey: ["tasks"] })
                }
                className="bg-white border border-slate-200 text-slate-700 hover:bg-slate-50"
              >
                Refresh
              </Button>
            </div>
          </div>
        </div>

        {/* Content Display */}
        {layoutMode === "cards" ? renderCardsView() : renderTableView()}

        {/* Pagination */}
        {filteredMetrics.length > 10 && (
          <div className="flex justify-center mt-8">
            <Pagination
              total={Math.ceil(filteredMetrics.length / 10)}
              page={currentPage}
              onChange={setCurrentPage}
              showControls
              color="success"
              className="gap-2"
            />
          </div>
        )}
      </div>

      {/* Create Task Modal */}
      <CreateTaskModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        onSuccess={handleCreateTaskSuccess}
        preSelectedMetric={null}
      />
    </div>
  );
};

export default TaskControlTrackerMain;
